
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';

export default function Help() {
  const navigate = useNavigate();

  const helpCategories = [
    {
      title: 'Getting Started',
      icon: 'ri-rocket-line',
      color: 'cyan',
      guides: [
        { title: 'Create Your Account', link: '/auth/signup' },
        { title: 'Complete KYC Verification', link: '/kyc' },
        { title: 'Fund Your Wallet', link: '/wallet' },
        { title: 'Make Your First Trade', link: '/trading' }
      ]
    },
    {
      title: 'Trading Guide',
      icon: 'ri-exchange-line',
      color: 'purple',
      guides: [
        { title: 'Understanding Spot Trading', link: '#' },
        { title: 'How to Use AI Trading Bot', link: '#' },
        { title: 'P2P Trading Explained', link: '/p2p' },
        { title: 'Reading Market Charts', link: '#' }
      ]
    },
    {
      title: 'Mining Guide',
      icon: 'ri-cpu-line',
      color: 'pink',
      guides: [
        { title: 'Choose a Mining Plan', link: '/mining' },
        { title: 'Configure Mining Settings', link: '#' },
        { title: 'Calculate Mining Profits', link: '#' },
        { title: 'Withdraw Mining Rewards', link: '#' }
      ]
    },
    {
      title: 'Security Best Practices',
      icon: 'ri-shield-check-line',
      color: 'green',
      guides: [
        { title: 'Enable Two-Factor Authentication', link: '#' },
        { title: 'Create Strong Passwords', link: '#' },
        { title: 'Recognize Phishing Attempts', link: '#' },
        { title: 'Secure Your Wallet', link: '#' }
      ]
    },
    {
      title: 'Wallet Management',
      icon: 'ri-wallet-line',
      color: 'orange',
      guides: [
        { title: 'Deposit Cryptocurrency', link: '/wallet' },
        { title: 'Withdraw Funds Safely', link: '#' },
        { title: 'Understanding Transaction Fees', link: '#' },
        { title: 'Track Your Portfolio', link: '#' }
      ]
    },
    {
      title: 'Account Settings',
      icon: 'ri-settings-line',
      color: 'blue',
      guides: [
        { title: 'Update Profile Information', link: '/profile' },
        { title: 'Change Password', link: '#' },
        { title: 'Manage Notifications', link: '#' },
        { title: 'Set Trading Preferences', link: '#' }
      ]
    }
  ];

  const quickLinks = [
    { title: 'FAQ', icon: 'ri-question-line', link: '/faq', color: 'cyan' },
    { title: 'Contact Support', icon: 'ri-customer-service-line', link: '/contact', color: 'purple' },
    { title: 'Terms & Conditions', icon: 'ri-file-text-line', link: '/terms', color: 'pink' },
    { title: 'Privacy Policy', icon: 'ri-shield-user-line', link: '/privacy', color: 'green' }
  ];

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      
      <div className="pt-16 px-4 sm:px-6 pb-6">
        <div className="max-w-7xl mx-auto">
          {/* Add Navigation Header */}
          <div className="flex items-center justify-between mb-6 sm:mb-8">
            <div className="flex items-center gap-2 sm:gap-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 sm:px-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white text-xs sm:text-sm hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-1 sm:mr-2"></i>
                Back
              </button>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-white">Help Center</h1>
                <p className="text-gray-400 text-sm">Find answers to common questions</p>
              </div>
            </div>
            <div className="flex items-center gap-2 sm:gap-3">
              <button
                onClick={() => navigate('/contact')}
                className="px-3 sm:px-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white text-xs sm:text-sm hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-customer-service-line mr-1 sm:mr-2"></i>
                Contact Support
              </button>
              <button
                onClick={() => navigate('/faq')}
                className="px-3 sm:px-4 py-2 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg text-white text-xs sm:text-sm hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-questionnaire-line mr-1 sm:mr-2"></i>
                FAQ
              </button>
            </div>
          </div>

          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-black text-white mb-4">
              Help Center
            </h1>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Comprehensive guides and tutorials to help you get the most out of PepCoin platform.
            </p>
          </div>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto mb-16">
            <div className="relative">
              <input
                type="text"
                placeholder="Search for help articles..."
                className="w-full px-6 py-4 pl-14 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors"
              />
              <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
            </div>
          </div>

          {/* Help Categories */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {helpCategories.map((category, index) => (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 hover:border-cyan-500/30 transition-all duration-300"
              >
                <div className={`w-14 h-14 rounded-xl bg-${category.color}-500/20 flex items-center justify-center mb-4`}>
                  <i className={`${category.icon} text-2xl text-${category.color}-400`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{category.title}</h3>
                <ul className="space-y-3">
                  {category.guides.map((guide, guideIndex) => (
                    <li key={guideIndex}>
                      <Link
                        to={guide.link}
                        className="text-gray-300 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line"></i>
                        {guide.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Quick Links */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">Quick Links</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {quickLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.link}
                  className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl p-6 hover:border-cyan-500/30 transition-all duration-300 text-center cursor-pointer"
                >
                  <div className={`w-16 h-16 mx-auto rounded-full bg-${link.color}-500/20 flex items-center justify-center mb-4`}>
                    <i className={`${link.icon} text-3xl text-${link.color}-400`}></i>
                  </div>
                  <h3 className="text-white font-semibold">{link.title}</h3>
                </Link>
              ))}
            </div>
          </div>

          {/* Video Tutorials */}
          <div className="bg-gradient-to-r from-cyan-500/10 to-purple-600/10 border border-cyan-500/30 rounded-2xl p-8 mb-16">
            <div className="text-center">
              <i className="ri-video-line text-5xl text-cyan-400 mb-4"></i>
              <h2 className="text-3xl font-bold text-white mb-3">Video Tutorials</h2>
              <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
                Watch step-by-step video guides to learn how to use PepCoin platform effectively.
              </p>
              <button className="px-8 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg text-white font-medium hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap">
                <i className="ri-play-circle-line mr-2"></i>
                Watch Tutorials
              </button>
            </div>
          </div>

          {/* Contact Support */}
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 text-center">
            <i className="ri-customer-service-line text-5xl text-purple-400 mb-4"></i>
            <h3 className="text-2xl font-bold text-white mb-3">
              Need More Help?
            </h3>
            <p className="text-gray-300 mb-6">
              Can't find what you're looking for? Our support team is available 24/7 to assist you.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="px-8 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg text-white font-medium hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                Contact Support
              </Link>
              <Link
                to="/faq"
                className="px-8 py-3 bg-white/10 border border-white/20 rounded-lg text-white font-medium hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-question-line mr-2"></i>
                View FAQ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
